import { OverrideNoteDetail } from "../../../../../../models/overrideNoteDetail";
class UploadResumesActionsModalController {
    constructor() {
        // this.candidateId = this.resolve.candidateId;
        // this.candidateName = this.resolve.candidateName;
        // this.suspendedMonths = this.resolve.suspendedMonths;
        // this.releaseDate = this.resolve.releaseDate;
        // this.allowOverride = this.resolve.allowOverride;
        // this.releasedJobDetails = this.resolve.releasedJobDetails;
        // this.type = this.resolve.type;
    }
    $onInit() {
        this.candidateId = this.resolve.candidateId;
        this.candidateName = this.resolve.candidateName;
        this.suspendedMonths = this.resolve.suspendedMonths;
        this.releaseDate = this.resolve.releaseDate;
        this.allowOverride = this.resolve.allowOverride;
        this.releasedJobDetails = this.resolve.releasedJobDetails;
        this.type = this.resolve.type;
        this.modalTitle = "Override";
        this.recruiterDetails = new OverrideNoteDetail(this.candidateId);
        this.callbackObject = { callbackType: 'cancel', entity: {} };
    }
    saveCallback() {
        this.callbackObject.callbackType = "save";
        this.callbackObject.entity = this.recruiterDetails;
        this.closeModal();
    }
    closeModal() {
        this.modalInstance.close(this.callbackObject);
    }
    dismissModal() {
        this.modalInstance.dismiss('cancel');
    }
}
// import * as TEMPLATE from './upload-resumes-actions-modal.html';
import * as TEMPLATE from 'raw-loader!./upload-resumes-actions-modal.html';
export const UploadResumesActionsModalComponent = {
    selector: 'uploadResumesActionsModal',
    component: {
        bindings: {
            modalInstance: "<",
            resolve: "<"
        },
        controller: UploadResumesActionsModalController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/addCandidates/addCandidates/uploadResumes/uploadResumesActionsModal/upload-resumes-actions-modal.html'
    }
};
//# sourceMappingURL=upload-resumes-actions-modal.component.js.map